module.exports = __webpack_public_path__ + "img/bg2.2a2092e7.png";